import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=624b2086&"
import script from "./ResizeObserver.js?vue&type=script&lang=js&"
export * from "./ResizeObserver.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../setup-pnpm/store/v11/links/@/vue-loader/15.10.2/4df48d78f583aab8cb7a79d5b07c76e21aa645336f56cb886eff36c580a62f81/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports